import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-action-btns',
  standalone: false,

  templateUrl: './action-btns.component.html',
  styleUrl: './action-btns.component.less'
})
export class ActionBtnsComponent {

  @Input() copy: boolean = true;
  @Input() file: boolean = true;
  @Input() message: boolean = true;
  @Input() messageUnread: boolean = true;
  @Input() drawer: boolean = true;
  @Input() options: boolean = false;
  @Input() isDoc: boolean = false;
  @Input() select:boolean = false;
  @Input() selectList:string[]=[];

  @Output() buttonClick = new EventEmitter<string>();

  // Método que se invoca al hacer click en cualquiera de los botones.
  onButtonClick(action: string, event: MouseEvent): void {
    event.stopPropagation();  // Evita que el click se propague al elemento padre
    this.buttonClick.emit(action);  // Emite un evento con la acción (p.ej. 'copy', 'file', etc.)
  }

}
